import { ListType } from '@epicuro-next/models/engagement';
import { Action, createReducer, on } from '@ngrx/store';

import {
  clearListItemsInPreparationToCreateList,
  setListItemsInPreparationToCreateList,
} from '../../actions';
import { ListItem } from '../../models/list-item';

export const createListFeatureKey = 'create-list';

export interface State {
  listItems: ListItem[];
  listType?: ListType;
}

export const initialState: State = {
  listItems: [],
  listType: undefined,
};

const createListReducer = createReducer(
  initialState,
  on(clearListItemsInPreparationToCreateList, (state): State => {
    return {
      ...state,
      listItems: [],
      listType: undefined,
    };
  }),
  on(setListItemsInPreparationToCreateList, (state, action): State => {
    return {
      ...state,
      listItems: action.listItems,
      listType: action.listType,
    };
  }),
);

/**
 * Exported function because of Angular AOT
 */
export function reducer(state: State | undefined, action: Action) {
  return createListReducer(state, action);
}
